<script setup lang="ts">
import { computed } from 'vue';
import type { IColumnDefinition, RowData, ITimeColumn } from '../types';

const props = defineProps<{
  value: any;
  row: RowData;
  column: IColumnDefinition;
}>();

const col = computed(() => props.column as ITimeColumn);
</script>

<template>
  <span class="text-nowrap">{{ value }}</span>
</template>
